import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseApplication,
  BaseButtonSize,
  BaseCoreState,
  BaseDeviceService,
  baseAuthSelectors,
  baseAuthActions,
} from 'base';

interface TodoList {
  title: string;
  text: string;
  image: string;
  buttonText: string;
  buttonLink: string;
}

@Component({
  selector: 'base-customer-onboarding-light',
  templateUrl: './onboarding-light.component.html',
})
export class BaseCustomerOnboardingLightComponent implements OnInit, OnDestroy {
  @Input() logo: string;
  @Input() application: BaseApplication;
  @Input() modalRef: NgbModalRef;
  @ViewChild('baseOnboardingLight', { static: true }) baseOnboardingLight: ElementRef;
  isMobileDevice: boolean;
  isFirstTimeLogin: boolean;
  buttonSize = BaseButtonSize;
  todos: TodoList[] = [
    {
      title: 'onboarding.maintainMasterData.title',
      text: 'onboarding.maintainMasterData.text',
      image: 'onboarding-maintain-master-data.svg',
      buttonText: 'onboarding.maintainMasterData.buttonText',
      buttonLink: '/administration/company-master-data',
    },
    {
      title: 'onboarding.userManagement.title',
      text: 'onboarding.userManagement.text',
      image: 'onboarding-user-management.svg',
      buttonText: 'onboarding.userManagement.buttonText',
      buttonLink: '/administration/user-management',
    },
    {
      title: 'onboarding.locationsAndDepartments.title',
      text: 'onboarding.locationsAndDepartments.text',
      image: 'onboarding-locations-and-departments.svg',
      buttonText: 'onboarding.locationsAndDepartments.buttonText',
      buttonLink: '/administration/location-management',
    },
    {
      title: 'onboarding.profile.title',
      text: 'onboarding.profile.text',
      image: 'onboarding-profile.svg',
      buttonText: 'onboarding.profile.buttonText',
      buttonLink: '/administration/user-settings',
    },
  ];

  private destroy$ = new Subject();

  constructor(private store: Store<BaseCoreState>, private deviceService: BaseDeviceService) {}

  ngOnInit() {
    this.isMobileDevice = !this.deviceService.isDesktop();
    this.store
      .select(baseAuthSelectors.getFirstTimeLoginStatus)
      .pipe(
        filter((status) => status !== undefined),
        takeUntil(this.destroy$)
      )
      .subscribe((status) => {
        this.isFirstTimeLogin = !!status;
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  closeModal(): void {
    this.store.dispatch(baseAuthActions.setFirstLoginIndicator({ payload: false }));
    this.modalRef.close();
  }
}
